import React from 'react';

const GlossaryJsonLd: React.FC = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "DefinedTermSet",
    "@id": "https://greentick.org.in/research#glossary",
    "name": "GreenTick Behavioral Capture Glossary",
    "description": "Technical terminology and logical frameworks defining the GreenTick AI assessment methodology.",
    "hasDefinedTerm": [
      {
        "@type": "DefinedTerm",
        "name": "Behavioral Capture",
        "description": "A methodology for technical assessment that prioritizes mapping a candidate's mental models and reasoning patterns over static answer verification.",
        "termCode": "BC-001"
      },
      {
        "@type": "DefinedTerm",
        "name": "N-Step Inference",
        "description": "The ability to reason through multiple recursive layers of system dependencies and trade-offs. GreenTick measures the depth of logical consistency across these steps.",
        "termCode": "NI-002"
      },
      {
        "@type": "DefinedTerm",
        "name": "Memorization Gap",
        "description": "The performance delta between candidates who excel at leetcode-style algorithmic puzzles through rote memorization versus those who possess deep architectural intent.",
        "termCode": "MG-003"
      },
      {
        "@type": "DefinedTerm",
        "name": "High-Signal Interaction",
        "description": "Dynamic interview prompts designed to test the boundary of a candidate's technical capability by injecting real-time constraints and logic shifts.",
        "termCode": "HSI-004"
      },
      {
        "@type": "DefinedTerm",
        "name": "Cognitive Delta",
        "description": "The measurable shift in response latency and articulation precision when shifting from memory recall to active system synthesis.",
        "termCode": "CD-005"
      }
    ]
  };

  return (
    <script 
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
};

export default GlossaryJsonLd;
